export type lelki_modul = {
  id: string;
  title: string;
  description: string[];
  sound: string;
};

export const lelki_modulok: lelki_modul[] = [
  {
    id: 'az-ur-a-te-orizod',
    title: 'Az Úr a te őriződ',
    description: [
      'Zarándokének.',
      'Tekintetem a hegyekre emelem: Honnan jön segítségem?',
      'Segítségem az ÚRtól jön, aki az eget és a földet alkotta.',
      'Nem engedi, hogy lábad megtántorodjék, nem szunnyad őriződ.',
      'Bizony nem szunnyad, nem alszik Izráel őrizője!',
      'Az ÚR a te őriződ, az ÚR a te oltalmad jobb kezed felől.',
      'Nem árt neked nappal a nap, sem éjjel a hold.',
      'Az ÚR megőriz téged minden bajtól, megőrzi életedet.',
      'Megőriz az ÚR jártodban-keltedben, most és mindenkor.',
    ],
    sound: 'Az_Úr_a_te_őriződ.m4a',
  },
  {
    id: 'vissza-a-termeszetbe',
    title: 'Vissza a természetbe!',
    description: [
      'Van valami varázslatos, semmihez sem fogható abban, ha kimegyünk a természetbe. Még ha a belvárosban élsz is, és már régóta alig látsz egy zöld csomót, azért csak van valahol a közelben egy park, ahová lemehetsz.',
      'Ryan egy családi zűr kellős közepén ismerte meg a természet gyógyító erejét.',
      'Valamikor középiskolás koromban egy elég nehéz időszakon mentem keresztül. Úgy tűnt, minden összeomlik körülöttem... Ekkor találtam rá egy különleges kis helyre a folyóparton. Egy öreg farmer földjének végén volt, néhány félreeső fa között, és messziről nem lehetett észrevenni, hogy van ott valami. Ez lett a rejtekhelyem. Senki sem volt a környéken, nem lehetett hallani az embereket. Gyönyörű volt. Ahogy ott úszkáltam, békében éreztem magam a természettel. Ha feszült voltam, mindig oda mentem. Úgy éreztem, mintha az életem újra visszazökkenne a normális kerékvágásba.',
      'Van, aki a problémáira a gyülekezetében, szervezett keretek között keres megoldást. Én is hiszek Istenben. De néha egyszerűen már arra is nehezen veszem rá magam, hogy elinduljak, és közösségbe menjek, mert ha elmegyek, mindenki azt mondja: „Ó, csak légy nyugodt. Meg fog oldódni az egész! Csak legyen hited! Minden rendben lesz a családodban.” Hát, szerintem ez süket duma. Van, ami nem oldódik meg. Az én családom egy katasztrófa...',
      'De ha lementem a folyóhoz, az a hely nem bírált. Nem mondta meg, mit csináljak. Csak ott volt. És ha átadtam magam a békéjének, nyugalmának, bennem is lecsendesültek a dolgok. Úgy éreztem, hogy talán mégis van remény...',
    ],
    sound: 'Vissza_a_természetbe.m4a',
  },
  {
    id: 'isten-megitel',
    title: 'Isten megítél',
    description: [
      'Örvendezz ifjú, míg fiatal vagy, légy jókedvű ifjúságod idején, és élj szíved vágya szerint, ahogy jónak látod. De tudd meg, hogy mindezekért Isten megítél téged!',
    ],
    sound: 'Isten_megítél.m4a',
  },
  {
    id: 'igazi-embertars',
    title: 'Igazi embertárs',
    description: [
      'Jézus erre egy történettel válaszolt: „Egyszer egy ember Jeruzsálemből Jerikóba utazott. Útközben rablók támadták meg, akik kifosztották, s még a ruháját is elvették, megverték, majd félholtan otthagyták. Nemsokára arra ment egy pap, de mikor meglátta a sebesültet, kikerülte, és otthagyta. Később egy lévita ment arra. Mikor meglátta a sebesültet, ő is átment az út másik oldalára, és otthagyta. Később arra utazott egy samáriai férfi is. Amikor meglátta a sebesültet, megsajnálta. Odament hozzá, olajat és bort öntött a sebeire, és bekötözte. Ezután feltette a saját szamarára, elvitte egy vendégfogadóba, és ott ápolta tovább. Másnap a fogadó gazdájának két ezüstpénzt adott, és azt mondta neki: »Gondoskodj erről az emberről, és amit ezen felül még ráköltesz, megfizetem, amikor visszajövök.«',
      'Mit gondoltok, a három közül melyik volt igazi embertársa annak, akit kiraboltak?”',
      'A törvénytanító így válaszolt: „Az, aki megsajnálta és segített rajta.”',
      'Jézus azt mondta: „Igazad van, menj, és kövesd a példáját!”',
    ],
    sound: 'Igazi_embertárs.m4a',
  },
  {
    id: 'adjatok-at-magatokat-istennek',
    title: 'Adjátok át magatokat Istennek',
    description: [
      'Isten irántunk mutatott nagy kegyelmére kérlek benneteket, testvéreim, hogy határozottan szánjátok oda és adjátok át magatokat Istennek! Olyan ez, mintha élő és szent áldozatot vinnétek neki, amelyet ő szívesen fogad. Ez legyen a ti önkéntesen fölajánlott áldozatotok, amellyel őt méltóképpen tisztelitek!',
      'Ne igazodjatok a jelenlegi istentelen korszellemhez, se a divatjaihoz! Ellenkezőleg, újítsátok meg az egész gondolkodásotokat, és ezáltal gyökeresen változzatok meg! Akkor lesztek majd képesek megérteni, mi az, amit Isten akar.',
      'Ha tehát megvallod, hogy Jézus az Úr, mert a szívedben hiszed, hogy Isten feltámasztotta őt a halálból, akkor üdvözülsz. Mert belül, a szívünkben jön létre az a hitbeli meggyőződés, amely Isten számára elfogadhatóvá tesz bennünket, és ha a szánkkal megvalljuk, amit hiszünk, akkor üdvözülünk.',
      'Azt mondja ugyanis az Írás: „Senki sem fog csalódni, aki benne hisz.”',
    ],
    sound: 'Adjátok_át_magatokat_Istennek.mp3',
  },
];
